<template>
  <span>
    <q-btn stack flat stretch
      icon="las la-angle-left"
      :label="isLabel ? $t('names.previous') : null"
      :disable="!username || !latLng"
      @click="previous"
    >
      <q-tooltip v-if="!isLabel">{{ $t('names.previous') }}</q-tooltip>
    </q-btn>
    <q-btn stack flat stretch
      icon="las la-angle-right"
      :label="isLabel ? $t('names.next') : null"
      :disable="!username || !latLng"
      @click="next"
    >
      <q-tooltip v-if="!isLabel">{{ $t('names.next') }}</q-tooltip>
    </q-btn>
    <q-btn stack flat stretch
      icon="las la-undo"
      :label="isLabel ? '90' : null"
      :disable="!username || !latLng"
      @click="rotate(90)"
    >
      <q-tooltip>
        {{ $t('tools.panorama.rotateLeft') }}
      </q-tooltip>
    </q-btn>
    <q-btn stack flat stretch
      icon="las la-sync"
      :label="isLabel ? '180' : null"
      :disable="!username || !latLng"
      @click="rotate(180)"
    >
      <q-tooltip>
        {{ $t('tools.panorama.rotate180') }}
      </q-tooltip>
    </q-btn>
    <q-btn stack flat stretch
      icon="las la-redo"
      :label="isLabel ? '90' : null"
      :disable="!username || !latLng"
      @click="rotate(-90)"
    >
      <q-tooltip>
        {{ $t('tools.panorama.rotateRight') }}
      </q-tooltip>
    </q-btn>
    <q-btn stack flat stretch
      :icon="!showLateral ? 'las la-camera' : 'panorama_horizontal'"
      :label="!isLabel ? '' : !showLateral ? $t('names.image') : $t('names.panorama')"
      :disable="!username || (!laterals || laterals.length === 0)"
      @click="activateLateral"
    >
      <q-tooltip>
        {{ !showLateral ? $t('tools.panorama.enableLateral') : $t('tools.panorama.enablePano') }}
      </q-tooltip>
    </q-btn>
    <q-btn stack flat stretch
      v-if="selectedCampaign"
      :label="!isLabel ? '' : !showLateral ? 'Info' : null"
      icon="las la-info-circle"
      @click="openCampaignDialog"
    >
      <q-tooltip>
        {{ $t('tools.panorama.infoCampaign') }}
      </q-tooltip>
    </q-btn>
    <q-dialog v-model="showCampaignDialog">
      <q-card v-if="selectedCampaign">
        <q-card-section class="row items-center q-py-md">
          <q-icon name="las la-info-circle" style="font-size: 1.5em;" class="q-pr-sm"/>
          <div class="text-h5 q-pr-lg">{{ selectedCampaign.name }}</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-separator />
        <q-card-section v-if="selectedCampaign.description" class="q-py-sm">
          <div class="text-subtitle2">{{ $t('tools.panorama.descriptionCampaign') }}</div>
          <div>{{ selectedCampaign.description }}</div>
        </q-card-section>

        <q-card-section v-if="selectedCampaign.zone" class="q-py-sm">
          <div class="text-subtitle2">{{ $t('tools.panorama.zoneCampaign') }}</div>
          <div>{{ selectedCampaign.zone }}</div>
        </q-card-section>

        <q-card-section v-if="selectedCampaign.date_start" class="q-py-sm">
          <div class="text-subtitle2">{{ $t('tools.panorama.startCampaign') }}</div>
          <div>{{ date_start }}</div>
        </q-card-section>

        <q-card-section v-if="selectedCampaign.date_start" class="q-py-sm">
          <div class="text-subtitle2">{{ $t('tools.panorama.endCampaign') }}</div>
          <div>{{ date_end }}</div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </span>
</template>

<script>
import { ClosePopup, QBtn, QCard, QCardSection, QDialog, QIcon, QSeparator, QSpace, QTooltip } from 'quasar'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  props: ['isHeader'],
  data () {
    return {
      showCampaignDialog: false,
      showDropdownCampaigns: false,
      showDropdownOptions: false
    }
  },
  components: {
    QBtn, QCard, QCardSection, QDialog, QIcon, QSeparator, QSpace, QTooltip
  },
  directives: {
    ClosePopup
  },
  computed: {
    ...mapState({
      username: state => state.auth.username,
      campaigns: state => state.panorama.campaigns,
      selectedCampaign: state => state.panorama.selectedCampaign,
      head: state => state.panorama.head,
      latLng: state => state.panorama.latLng,
      laterals: state => state.panorama.laterals,
      showLateral: state => state.panorama.showLateral,
      showPannellum: state => state.panorama.showPannellum,
      showPotree: state => state.panorama.showPotree
    }),
    date_start () {
      return this.selectedCampaign.date_start && moment(this.selectedCampaign.date_start).format('DD/MM/YYYY')
    },
    date_end () {
      return this.selectedCampaign.date_end && moment(this.selectedCampaign.date_end).format('DD/MM/YYYY')
    },
    isLabel () {
      return this.isHeader && this.$q.screen.gt.md
    }
  },
  methods: {
    activateLateral () {
      const isActive = this.$store.state.panorama.showLateral
      if (!isActive) {
        this.$store.dispatch('panorama/selectLateral')
      } else {
        this.$store.commit('panorama/setSelectedLateral', null)
      }
      this.$store.commit('panorama/setShowLateral', !isActive)
    },
    previous () {
      this.$store.dispatch('panorama/getPreviousPano')
    },
    next () {
      this.$store.dispatch('panorama/getNextPano')
    },
    rotate (angle) {
      const head = this.head + angle
      this.$store.commit('panorama/setHead', { head, from: 'tools' })
      const isActive = this.$store.state.panorama.showLateral
      if (isActive) {
        this.$store.dispatch('panorama/selectLateral')
      }
    },
    openCampaignDialog () {
      this.showCampaignDialog = true
    }
  }
}
</script>
